import type {ReactNode} from 'react'
import type {LucideIcon} from 'lucide-react'
import {cn} from '@/lib/utils'
import {useIsEmbedded} from './EmbeddedContext'

interface PageSectionHeaderProps {
    title: string
    titleTestId?: string
    description?: string | ReactNode
    descriptionTestId?: string
    icon?: LucideIcon
    actions?: ReactNode
    embedded?: boolean
    className?: string
}

export function PageSectionHeader({
    title,
    titleTestId,
    description,
    descriptionTestId,
    icon: Icon,
    actions,
    embedded,
    className,
}: PageSectionHeaderProps) {
    const contextEmbedded = useIsEmbedded()
    const isEmbedded = embedded ?? contextEmbedded
    return (
        <div className={cn('flex items-center justify-between mb-6', className)}>
            {!isEmbedded && (
                <div>
                    <h1
                        data-testid={titleTestId}
                        className={cn(
                            'font-bold tracking-tight',
                            Icon
                                ? 'text-3xl flex items-center gap-3'
                                : 'text-3xl',
                        )}
                    >
                        {Icon && <Icon className="h-8 w-8"/>}
                        {title}
                    </h1>
                    {description !== undefined && (
                        <p data-testid={descriptionTestId} className="text-muted-foreground mt-2">{description}</p>
                    )}
                </div>
            )}
            {actions !== undefined && (
                <div className={isEmbedded ? 'ml-auto' : undefined}>{actions}</div>
            )}
        </div>
    )
}
